"use client";

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import { Patch } from "@/shared/libs/axios/request";
import { orderKeys } from "@/entities/order";
import type { ProductResponse, UpdateProductRequest } from "@stocks/shared";

export const useUpdateProduct = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, values }: { id: string; values: UpdateProductRequest }) =>
      Patch<ProductResponse, UpdateProductRequest>(`/v1/products/${id}`, values),
    onSuccess: (res) => {
      qc.invalidateQueries({ queryKey: [orderKeys.products] });
      toast.success(res.data.message);
    },
    onError: (error) =>
      toast.error(error.response?.data.message ?? "제품 수정에 실패했습니다."),
  });
};
